import React from 'react';
import { Link } from 'react-router-dom';

function ServicesOneCard({ bgImg, icon, heading, text, link }) {
    return (
        <div className="col-md-6 col-xl-3 col-12">
            <Link to={link} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="single-service-item service-1">
                    <div
                        className="service-bg bg-cover"
                        style={{
                            backgroundImage: `url(${bgImg})`,
                        }}
                    />
                    <div className="icon">
                        <img src={icon} alt="icon" />
                    </div>
                    <h3>{heading}</h3>
                    <div className="service-hover-content">
                        <p>{text}</p>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default ServicesOneCard;
